import {computed, Injectable, Signal, signal} from "@angular/core";
import {AgendaelementId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";

/** Tjeneste for å vedlikeholde og koordinere informasjon om aktiv sak. */
@Injectable({providedIn: 'root'})
export class ValgtSakRegister {

    private readonly valgtSak = signal<AgendaelementId | null>(null);

    constructor() {
    }

    setValgt(agendaelementId: AgendaelementId): void {
        this.valgtSak.set(agendaelementId);
    }

    nullstillValgt(): void {
        this.valgtSak.set(null);
    }

    get valgt(): Signal<AgendaelementId | null> {
        return this.valgtSak.asReadonly();
    }

    get erNoenValgt(): Signal<boolean> {
        return computed(() => erIkkeNil(this.valgtSak.asReadonly()));
    }
}
